import { SystemStyleObject, rem } from '@vimeo/bokeh';
import { OPACITY_FROM_HIDDEN_TO_VISIBLE_KEYFRAMES } from '@vimeo/live-core/utils/styling/keyframes';

export function createAvatarWrapperStyle(): SystemStyleObject {
  return {
    flexShrink: 0,
    height: rem(32),
    width: rem(32),
    margin: 0,
  };
}

export function createQuestionTextStyle(): SystemStyleObject {
  return {
    color: 'text-primary',
    margin: 0,
    wordWrap: 'break-word',
    maxWidth: '100%',
    lineHeight: rem(20),
  };
}

export const TIME_ASKED_STYLE: SystemStyleObject = {
  color: 'text-secondary',
  margin: 0,
  flexShrink: 0,
  lineHeight: rem(16),
};

export const QUESTION_HEADER_STYLE: SystemStyleObject = {
  position: 'relative',
  width: '100%',
  minWidth: 0,
  alignItems: 'center',
  marginBottom: rem(8),
};

export function createQuestionInfoStyle(): SystemStyleObject {
  return {
    flexDirection: 'row',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    width: '100%',
    minWidth: 0,
    columnGap: rem(8),
    paddingRight: rem(48),
  };
}

export function createQuestionControlsStyle({
  isActive,
  isAnswering,
}: {
  isActive?: boolean;
  isAnswering?: boolean;
}): SystemStyleObject {
  return {
    button: {
      transition: 'background 0s linear, color 0s linear',
      ...(isActive && !isAnswering
        ? {
            background: 'blue.500',
            color: 'white',

            '&:hover': {
              background: 'blue.400',
            },
          }
        : {}),
    },
  };
}

export function createQuestionItemChildrenGroupHoverStyle({
  themeName,
  isActive,
  isAnswering,
}: {
  themeName: string;
  isActive?: boolean;
  isAnswering?: boolean;
}): SystemStyleObject {
  return themeName === 'light' && !isActive && !isAnswering
    ? {
        button: {
          background: 'slate.600',
          color: 'white',

          '&:hover': {
            background: 'slate.500',
          },
        },
      }
    : {};
}

export function createQuestionItemWrapperStyle({
  themeName,
  isArchived,
  isPinned,
  isHovered,
}: {
  themeName: string;
  isArchived?: boolean;
  isPinned?: boolean;
  isHovered?: boolean;
}): SystemStyleObject {
  return {
    borderRadius: 'md',
    border: `${rem(1)} solid`,
    animation: `${OPACITY_FROM_HIDDEN_TO_VISIBLE_KEYFRAMES} 750ms`,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: rem(8),
    padding: rem(8),
    maxWidth: '100%',
    overflow: 'visible',
    transition: 'border-width 0.1s ease-in-out',
    position: 'relative',

    ...(isPinned
      ? {
          borderWidth: rem(2),
          ...(themeName === 'dark'
            ? {
                backgroundColor: 'grayscale.900',
                borderColor: 'slate.100',
              }
            : {
                backgroundColor: 'grayscale.50',
                borderColor: 'grayscale.680',
              }),
        }
      : {
          borderWidth: rem(1),
          borderColor: themeName === 'dark' ? 'transparent' : 'stroke',
        }),

    ...(isHovered
      ? {
          backgroundColor: 'fill-component-hover',
          ...(!isArchived ? { cursor: 'pointer' } : {}),
        }
      : {}),
  };
}
